import React from "react";
import styled from "styled-components";

const CellContainer = styled.div<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  padding: 16px;
  &:first-child {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
  &:last-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  margin-bottom: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

interface ImageAndTextListCellProps {
  imageComponent: React.ReactNode;
  textComponent: React.ReactNode;
  bgColor: string;
}

const ImageAndTextListCell = ({ imageComponent, textComponent, bgColor }: ImageAndTextListCellProps) => (
  <CellContainer bgColor={bgColor}>
    {imageComponent}
    {textComponent}
  </CellContainer>
);

export default ImageAndTextListCell;
